
import { compose, mdsWidget } from 'dojo/_base/declare';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import template from './TimeZoneSelector.html?raw';
import docu from './TimeZoneSelectorDocumentation.html?raw';
import SelectBox from '../SelectBox/SelectBox';
import "../SelectBox/SelectBox";
import { AccessibilityLabelsHelper } from "../../../more/Helpers";





interface _value {
    utc_date: string,
    timezone: string
}
class TimeZoneSelector extends compose(_LabelInputBase) {
    templateString: any = template;

    inputNode: MdsLax<InstanceType<typeof SelectBox>>;
    labelNode: HTMLLabelElement;
    errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer: string = "errorMsgNode";

    inputDate: Date;

    _value: _value = {
        utc_date: null, // Iso string -- CAUTION!! Use custom this.toStringISO() method, and not Date.prototype.toISOString(). Custom method does not calculates the local offset.
        timezone: null // this.TimeZoneId_iana[i]
    };

    UTC_offset: number;
    utc_dateTime: Date;
    utc_number: number;
    //selectedLocaleDate_string: string;
    selectedLocaleDate_Date: Date;


    preferredTimezones: Array<string> = [];
    protected topZones: Array<string> = [];

    TimeZoneId_iana: Array<string> = ['Africa/Algiers', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Harare', 'Africa/Johannesburg', 'Africa/Monrovia', 'Africa/Nairobi', 'America/Argentina/Buenos_Aires', 'America/Bogota', 'America/Caracas',
        'America/Chicago', 'America/Chihuahua', 'America/Denver', 'America/Godthab', 'America/Guatemala', 'America/Guyana', 'America/Halifax', 'America/Indiana/Indianapolis', 'America/Juneau', 'America/La_Paz', 'America/Lima', 'America/Lima',
        'America/Los_Angeles', 'America/Mazatlan', 'America/Mexico_City', 'America/Mexico_City', 'America/Monterrey', 'America/Montevideo', 'America/New_York', 'America/Phoenix', 'America/Regina', 'America/Santiago', 'America/Sao_Paulo',
        'America/St_Johns', 'America/Tijuana', 'Asia/Almaty', 'Asia/Baghdad', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Bangkok', 'Asia/Chongqing', 'Asia/Colombo', 'Asia/Dhaka', 'Asia/Dhaka', 'Asia/Hong_Kong', 'Asia/Irkutsk', 'Asia/Jakarta',
        'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Karachi', 'Asia/Kathmandu', 'Asia/Kolkata', 'Asia/Kolkata', 'Asia/Kolkata', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuwait', 'Asia/Magadan',
        'Asia/Muscat', 'Asia/Muscat', 'Asia/Novosibirsk', 'Asia/Rangoon', 'Asia/Riyadh', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Tokyo',
        'Asia/Tokyo', 'Asia/Tokyo', 'Asia/Ulaanbaatar', 'Asia/Urumqi', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Cape_Verde', 'Atlantic/South_Georgia', 'Australia/Adelaide',
        'Australia/Brisbane', 'Australia/Darwin', 'Australia/Hobart', 'Australia/Melbourne', 'Australia/Melbourne', 'Australia/Perth', 'Australia/Sydney', 'Etc/UTC', 'Europe/Amsterdam', 'Europe/Athens', 'Europe/Belgrade', 'Europe/Berlin',
        'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Helsinki', 'Europe/Istanbul', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Lisbon',
        'Europe/Ljubljana', 'Europe/London', 'Europe/London', 'Europe/Madrid', 'Europe/Minsk', 'Europe/Moscow', 'Europe/Moscow', 'Europe/Paris', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/Sarajevo', 'Europe/Skopje',
        'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zagreb', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Auckland', 'Pacific/Fakaofo', 'Pacific/Fiji',
        'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Majuro', 'Pacific/Midway', 'Pacific/Midway', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Port_Moresby', 'Pacific/Tongatapu'];

    // Event

    _onChangeInputNode(): void {

        this.setValue(this.inputNode.getValue());

    }


    // Methods

    setValue(newValue: string, suppressChangeEvent: boolean = false): void {
        this._value.timezone = newValue;

        if (this.inputDate) {

            this.setUTC_offset(this.inputDate, this._value.timezone);
            this.adjustDateInputValue();
        }
        if (suppressChangeEvent === true) { }
        else {
            this.__delayValueChangeEmit();
        }
    }

    adjustDateInputValue(): void {
        
        this.selectedLocaleDate_Date = new Date(this.utc_number + this.UTC_offset);
        
    }

    setInputDate(date: Date): void { //// !!! must pass the dateInpu Widget Date to this Method in the parent Widget !!! ////

        if (date && Object.prototype.toString.call(date) === "[object Date]") {

            if (!isNaN(date.getFullYear())) {
                this.inputDate = date;
                this._value.timezone = this.inputNode.getValue();
                this.setUTC_offset(this.inputDate, this.inputNode.getValue());
                this.setDateProps();
                this.selectedLocaleDate_Date = new Date(this.inputDate.setMilliseconds(0));
            } else {
                console.log("invalid Date Format");
            }

        } else {
            console.log("invalid Date Format");
        }
    }
    
    setDateProps(): void {

        this.utc_number = this.inputDate.setMilliseconds(0) - this.UTC_offset;
        this.utc_dateTime = new Date(this.utc_number);
        this._value.utc_date = this.toStringISO(this.utc_dateTime);

    }

    setUTC_offset(date: Date, tz: string): void {
        
        let date_localString: string = date.toLocaleString("ja", { timeZone: tz });
        let ParamsStr: Array<string> = date_localString.split(/[:\s\/]/);
        let ParamsNum: Array<number> = ParamsStr.map(function (value: string): number { return Number(value); });
        ParamsNum[1]--;

        let utc_number: number = Date.UTC.apply(null, ParamsNum);
        let locale_number: number = date.setMilliseconds(0);
        this.UTC_offset = (utc_number - locale_number);

    }

    populateSelect(node: MdsLax<InstanceType<typeof SelectBox>>): void {
        ////--------------------------------------------------------my stuff (data for backend : TZName and offset in seconds)
        //let backendObj: Array<object> = [];
        ////--------------------------------------------------------my stuff (data for backend : TZName and offset in seconds)

        if (this.topZones.length > 0) {
            for (var i = 0; i < this.topZones.length; i++) {
                let zone = this.topZones[i];
                let zoneLabel: string;
                this.setUTC_offset(new Date(), zone);
                let offsetHours: number = this.UTC_offset / 60 / 1000 / 60;
                if (offsetHours < 0) {
                    zoneLabel = zone + ": UTC " + offsetHours + ":00";
                } else {
                    zoneLabel = zone + ": UTC +" + offsetHours + ":00";
                }
                
                node.addEntry(zone, zoneLabel, true);
            }

            node.addEntry("", "&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473", false);
        }

        for (var i = 0; i < this.TimeZoneId_iana.length; i++) {
            let zone = this.TimeZoneId_iana[i];
            let zoneLabel: string;
            this.setUTC_offset(new Date(), zone);
            let offsetHours: number = this.UTC_offset / 60 / 1000 / 60;
            if (offsetHours < 0) {
                zoneLabel = zone + ": UTC " + offsetHours + ":00";
            } else {
                zoneLabel = zone + ": UTC +" + offsetHours + ":00";
            }
            node.addEntry(zone, zoneLabel, true);
            ////--------------------------------------------------------my stuff (data for backend : TZName and offset in seconds)
            //backendObj.push({ timezone: zone, utc_offset: this.UTC_offset/1000 });
            ////--------------------------------------------------------my stuff (data for backend : TZName and offset in seconds)
        }
        ////--------------------------------------------------------my stuff (data for backend : TZName and offset in seconds)
        //console.log("tzObj::: ",backendObj);
        ////--------------------------------------------------------my stuff (data for backend : TZName and offset in seconds)


        node.setPlaceholder("bitte wählen - please choose");

        this.UTC_offset = null;
        this.utc_dateTime = null;

        //setDefault Value
        let defaultZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (this.TimeZoneId_iana.indexOf(defaultZone) != -1) {

            node.setValue(defaultZone, true);
            this._onChangeInputNode();

        }

        node.startup();
    }

    addPreferredTimezones(): void {

        if (this.preferredTimezones.length > 0) {
            for (let i = 0; i < this.preferredTimezones.length; i++) {
                let zone: string = this.preferredTimezones[i];
                for (let i = 0; i < this.TimeZoneId_iana.length; i++) {

                    if (this.TimeZoneId_iana[i] == zone) {
                        this.topZones.push(this.TimeZoneId_iana[i]);
                    }
                }
            }
        }
    }

    // konvertiert Date Object to String in ISO Format without calculating timezone offset
    toStringISO(date: Date): string {

        if (date && Object.prototype.toString.call(date) === "[object Date]") {

            if (isNaN(date.getFullYear())) {
                return null;
            }

            let day = ("0" + date.getDate()).slice(-2); //DD
            let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
            let year = date.getFullYear(); //YYYY
            let hours = ("0" + date.getHours()).slice(-2); // HH
            let min = ("0" + date.getMinutes()).slice(-2);  // mm
            let sec = ("0" + date.getSeconds()).slice(-2); // ss

            // YYYY-MM-DDTHH:mm:ss
            let ISOString = year + "-" + month + "-" + day + "T" + hours + ":" + min + ":" + sec;
            return ISOString;
        }

        return null;
    }

    // Getters und setters
    
    getUtcOffset(): number {
        return this.UTC_offset;
    }

    getUtcDate(): Date {
        return this.utc_dateTime;
    }

    getSelectedLocaleDate_Date(): Date {
        return this.selectedLocaleDate_Date;
    }

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    setValidationEnabled(bool: boolean): void {
        this.inputNode.setValidationEnabled(bool);
    }

    setMandatory(bool:boolean): void {
        this.inputNode.setMandatory(bool);
    }


    // Dojo

    _setisMandatoryAttr(bool: boolean): void {
        this.setMandatory(bool);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode.domNode, "timeZoneInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.addPreferredTimezones();
        this.populateSelect(this.inputNode);
    }
}

export default mdsWidget(TimeZoneSelector);